var exports = {
  "WW": "columnListNav__AJPq_u",
  "U9": "headingActions__iLs9nG",
  "pW": "leadingVisual__6MIdsq",
};

module.exports = exports;
